import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'filter-with-komitent',
  templateUrl: './filter-with-komitent.component.html'
})
export class FilterWithKomitentComponent extends BaseDefaultListFilterComponent implements OnInit {
  loadingEUInvoiceStatus:boolean = false;
    StatusDescription:string="";
    collapsed1:boolean=true;
    StatusRefreshTime:Date;
    @Output() CheckInputDocumentAndRefreshStatusClicked = new EventEmitter(false);
    @Input() showStatusBox:boolean=false;
    loadingFilter: boolean = false;

  constructor(protected datePipe: DatePipe
  ){
    super(datePipe);
  }

  selectedKomitent: string = 'Svi';
  refreshButtonDisabled: boolean = false;

  ngOnInit() {
    this.SetInitParameters();
    this.filterFormGroup.setValidators(this.CheckBrojDana('DanaZaOsvezavanje'));
  }

  SelectKomitent(item: KomitentView){
    this.selectedKomitent = item != null ? item.Naziv + ', ' + item.Mesto : 'Svi';
}

SetFilterDescription(){
    super.SetFilterDescription();
    this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                             ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') +
                             ', Komitent: ' + this.selectedKomitent;
}

SetStatusDescription(){
    this.StatusDescription='Osveženo '
     +this.StatusRefreshTime.getHours().toString().padStart(2, "0")
      +":"+this.StatusRefreshTime.getMinutes().toString().padStart(2, "0")
      +":"+this.StatusRefreshTime.getSeconds().toString().padStart(2, "0")
     +' za dokumenta stara do '
     +this.filterFormGroup.get("DanaZaOsvezavanje").value.toString()
     +' dana.';
}


SetInitParameters(){
    super.SetInitParameters();
    let date = new Date();
    this.filterFormGroup = new FormGroup({
        DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
        DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required]),
        KomitentID: new FormControl()
        , DanaZaOsvezavanje: new FormControl(5, [this.checkIfMoreThanThree])
    })
}

checkIfMoreThanThree(control) {
  const value = control.value;
  return value > 31 ? { moreThanThree: true } : null;
}

// RefreshStatusClick(id : number){
 CheckInputDocumentAndRefreshStatusClick(){
    this.loadingFilter = true;
    this.CheckInputDocumentAndRefreshStatusClicked.emit(this.filterFormGroup.get("DanaZaOsvezavanje").value);

    // this.StatusRefreshTime=new Date();
    // this.loadingFilter = false;
    // this.SetStatusDescription();
    // this.collapsed1=true;
}


CheckBrojDana(DanaZaOsvezavanjeKey:string){
  return (group: FormGroup): {[key : string]: any} =>{
   let danaZaOsvezavanje = group.controls[DanaZaOsvezavanjeKey].value;

   if (danaZaOsvezavanje > 31){
    this.refreshButtonDisabled = true;
       return { checkControls :{valid:false, message: 'FILTER.SPINER.VALIDATION.MAXNUM'}};
    }else{
      this.refreshButtonDisabled = false;
    }
  }
}


}
